import * as React from 'react';
import styled from 'styled-components';

import ClientOnly from 'components/ClientOnly';

import { StyledSlide } from './CarouselSlide';
import { CarouselContext } from './CarouselContext';

const StyledSlidesContainer = styled('ul')`
  align-items: ${(p) => p.$align || 'stretch'};
  display: grid;
  gap: var(--gap, 0px);
  max-width: 100%;
  transform: scaleZ(1);
  width: fit-content;

  &:focus:not(:focus-within) {
    outline: none;
  }

  &[data-mode='fade'] {
    grid-template: 100% / 1fr;

    ${StyledSlide} {
      grid-column: 1;
      grid-row: 1;
      width: 100%;
      height: 100%;
    }
  }

  &[data-mode='slide'] {
    grid-auto-columns: minmax(auto, 100%);
    grid-auto-flow: column;
    overflow-x: auto;
    overflow-y: hidden;
    overscroll-behavior-inline: contain;
    scroll-snap-type: inline mandatory;
    scrollbar-width: none;

    ::-webkit-scrollbar {
      display: none;
    }

    &[data-justify='start'] {
      scroll-padding-left: var(--offset-inline-start, 0);
    }

    ${StyledSlide} {
      scroll-snap-align: ${(props) => props['data-justify']};
      scroll-snap-stop: always;
    }

    ${StyledSlide}:first-of-type {
      margin-left: var(--offset-inline-start, 0px);
    }

    ${StyledSlide}:last-of-type {
      margin-right: var(--offset-inline-end, 0px);
    }
  }
`;

export default function CarouselSlides({ children, ...props }) {
  const context = React.useContext(CarouselContext);

  if (!context) {
    // Handle error
    return null;
  }

  const { getSlidesContainerProps, state } = context;

  return (
    <ClientOnly>
      <StyledSlidesContainer
        {...getSlidesContainerProps(props)}
        $align={state.options.alignSlides}
        data-justify={state.options.justifySlides}
        data-mode={state.options.mode}
        style={{
          ...(props.style ?? {}),
          '--gap': toCSSLengthString(state.options.gap),
          '--offset-inline-start': toCSSLengthString(
            state.offset.start ?? state.options.offset
          ),
          '--offset-inline-end': toCSSLengthString(
            state.offset.end ?? state.options.offset
          ),
        }}
      >
        {children}
      </StyledSlidesContainer>
    </ClientOnly>
  );
}

function toCSSLengthString(value) {
  return typeof value === 'number' ? `${value}px` : value;
}
